module.exports = __webpack_public_path__ + "img/18.1655c5af.webp";